import { render } from "./AlertPendingTimeOff.vue?vue&type=template&id=b2bff112&scoped=true"
import script from "./AlertPendingTimeOff.vue?vue&type=script&lang=js"
export * from "./AlertPendingTimeOff.vue?vue&type=script&lang=js"

import "./AlertPendingTimeOff.vue?vue&type=style&index=0&id=b2bff112&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2bff112"]])

export default __exports__